import * as React from 'react';
import { DatasheetItem } from '@modules/datasheets/components/datasheet-item';
import { DatasheetItemLabel } from '@modules/datasheets/components/datasheet-item-label';
import { MovableItem } from '../movable-item';
import { TextFieldProps, useTextFieldController } from './text-field.controller';
import { Flex } from '@common/components/Flex';
import { Hint } from '@common/components/hint';
import { DatasheetFieldComponentHeadingPosition } from '@common/dto/datasheet/field-component/heading-position';
import { TabOrder } from '../tab-order';

import './text-field.styles.scss';

export const TextField: React.FC<TextFieldProps> = React.memo((props) => {
  const { datasheetElement, multipleElementsSelected, isTabOrderSettingActive } = props;

  const { 
    coordinates,
    datasheetElementSelected,
    handleDatasheetElementMouseDown,
    movableElementRef,
    handleResizing,
    size,
    headingReference,
    headingPlacedHorizontally,
    headingSize,
    headingPosition,
    handleTabOrderChange,
  } = useTextFieldController(props);

  const labelComponent = (
    <DatasheetItemLabel
      reference={headingReference}
      inline={headingPlacedHorizontally}
      withImg={datasheetElement.original.showfieldtype}
      withText={datasheetElement.original.headdisplay}
      text={datasheetElement.original.headtext} 
      img={datasheetElement.original.field.imageURL}
      textCustomization={{
        fontSize: datasheetElement.original.headfontsize,
        fontFamily: datasheetElement.original.headfont,
        color: datasheetElement.original.headcolor,
        align: datasheetElement.original.headalign,
        fontStyles: datasheetElement.original.headstyle,
      }}
    />
  );

  return (
    <DatasheetItem
      style={{
        top: coordinates.y - (datasheetElement.original.headpos === DatasheetFieldComponentHeadingPosition.top 
          ? headingSize.height
          : 0),
        left: coordinates.x - (datasheetElement.original.headpos === DatasheetFieldComponentHeadingPosition.left 
          ? headingSize.width 
          : 0),
        display: headingPlacedHorizontally ? 'flex' : 'block',
        alignItems: headingPlacedHorizontally ? 'flex-start' : undefined,
      }}
    >
      {[
        DatasheetFieldComponentHeadingPosition.top, 
        DatasheetFieldComponentHeadingPosition.left
      ].includes(headingPosition) && labelComponent}
      <Flex>
        <MovableItem
          resizing={{
            enabled: isTabOrderSettingActive ? false : !multipleElementsSelected,
            onChange: handleResizing,
          }}
          moving={{
            enabled: !isTabOrderSettingActive,
          }}
          onClick={isTabOrderSettingActive ? handleTabOrderChange : undefined}
          showBorder={datasheetElement.original.showborder}
          reference={movableElementRef}
          height={size.height}
          width={size.width}
          selected={datasheetElementSelected}
          onMouseDown={isTabOrderSettingActive ? undefined : handleDatasheetElementMouseDown}
        />
        {isTabOrderSettingActive && (
          <TabOrder 
            value={datasheetElement.original.taborder}
          />
        )}
        {!isTabOrderSettingActive && datasheetElement.original.helptext && (
          <Hint className="DatasheetsEditorDatasheetTextField__hint" description="" />
        )}
      </Flex>
      {[
        DatasheetFieldComponentHeadingPosition.bottom, 
        DatasheetFieldComponentHeadingPosition.right
      ].includes(headingPosition) && labelComponent}
    </DatasheetItem>
  );
});